import Layout from 'layout/pcLayout.vue'
import Home from 'views/Home.vue'
export const PCRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/pc/home',
    children: [
      // 登录
      {
        path: '/pc/logIn',
        name: 'logIn',
        component: () => import('../views/logIn.vue')
      },
      // 注册
      {
        path: '/pc/register',
        name: 'register',
        component: () => import('../views/register.vue')
      },
      // 首页
      {
        path: '/pc/home',
        name: 'Home',
        component: Home
      },
      // {
      //   path: "/test",
      //   name: "HomeTest",
      //   component: Test,
      // },
      // 大赛背景
      {
        path: '/pc/backgroundOfTheCompetition',
        name: 'backgroundOfTheCompetition',
        component: () => import('../views/backgroundOfTheCompetition.vue')
      },
      // 最新资讯
      {
        path: '/pc/latestNews',
        name: 'latestNews',
        component: () => import('../views/latestNews.vue')
      },
      {
        path: '/pc/latestNewsDetail',
        name: 'latestNewsDetail',
        component: () => import('../views/latestNewsDetail.vue'),
        meta: { title: '资讯详情', activeMenu: 'latestNews' }
      },
      // 大赛十强名单页
      {
        path: '/pc/finalists',
        name: 'finalists',
        component: () => import('../views/finalists.vue')
      },
      // 历届比赛花絮
      {
        path: '/pc/previousCompetition',
        name: 'previousCompetition',
        component: () => import('../views/previousCompetition.vue')
      },
      {
        path: '/pc/interestingSidelightsTwo',
        name: 'interestingSidelightsTwo',
        component: () => import('../views/PC/interesting-sidelights-two.vue')
      },
      // 更多照片
      {
        path: '/pc/first-competition-gallery',
        name: 'first-competition-gallery',
        component: () => import('../views/morePhoto.vue')
      },
      {
        path: '/pc/first-more-image',
        name: 'first-more-image',
        component: () => import('../views/PC/more-image.vue')
      },
      {
        path: '/pc/speak-sustainability-contest',
        name: 'speak-sustainability-contest',
        component: () => import('../views/awards.vue')
      },
      {
        path: '/pc/secondCompetition',
        name: 'secondCompetition',
        component: () => import('../views/secondCompetition.vue')
      },
      {
        path: '/pc/pc_wd',
        name: 'pc_wd',
        component: () => import('../views/pc_wd.vue')
      },
      // 常见问题
      {
        path: '/pc/commonProblem',
        name: 'commonProblem',
        component: () => import('../views/commonProblem.vue')
      },
      {
        path: '/pc/commonProblemDetail',
        name: 'commonProblemDetail',
        component: () => import('../views/commonProblemDetail.vue'),
        meta: { title: '问题描述', activeMenu: 'commonProblem' }
      },
      // 关于我们
      {
        path: '/pc/aboutUs',
        name: 'aboutUs',
        component: () => import('../views/aboutUs.vue')
      },

      // 联络我们
      {
        path: '/pc/findUs',
        name: 'findUs',
        component: () => import('../views/findUs.vue')
      },
      // 大赛报名
      {
        path: '/pc/contestRegistration',
        name: 'contestRegistration',
        component: () => import('../views/contestRegistration.vue')
      },

      // 个人中心
      {
        path: '/pc/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter/index.vue')
      }
    ]
  }
]
